import config from '../utils/config';
import { getLocalStorage } from '../utils/func';
import { abortable } from '../utils/abortable';

// Optional engagement requests fail silently in the coordinator, never block
// the feed, and never retry a non-idempotent claim behind the user's back.
export async function inAppRequest(path, { method = 'GET', body, signal, token = getLocalStorage(config.token) } = {}) {
  if (!token || token !== getLocalStorage(config.token)) throw new Error('IN_APP_SESSION_CHANGED');
  const controller = new AbortController();
  const abort = () => controller.abort();
  if (signal?.aborted) abort();
  signal?.addEventListener('abort', abort, { once: true });
  const timeout = setTimeout(abort, 8000);
  const cancelled = new DOMException('In-app request aborted', 'AbortError');
  try {
    const response = await abortable(fetch(`${process.env.REACT_APP_API_URL}/in-app${path}`, {
      method, signal: controller.signal, cache: 'no-store',
      headers: { 'Content-Type': 'application/json', [config.token]: token },
      ...(body === undefined ? {} : { body: JSON.stringify(body) }),
    }), controller.signal, cancelled);
    const data = await abortable(response.json(), controller.signal, cancelled);
    if (!response.ok || data.success !== true || token !== getLocalStorage(config.token)) throw new Error('IN_APP_UNAVAILABLE');
    return data;
  } finally { clearTimeout(timeout); signal?.removeEventListener('abort', abort); }
}
